import type { MessageRole } from '@/schemas/commons';

import type { BubbleSide } from './ChatBubble.types';

/**
 * WhatsApp shape: the customer on the left, the bot on the right. Side carries
 * as much signal as colour and survives colour blindness, which is why the
 * palette never encodes anything in hue alone.
 *
 * `human` covers the customer *and* a human support agent taking over after a
 * handoff — `MessageRole` has no value that separates them and the backend
 * stamps both with the same `author_name`. Documented as an accepted limitation
 * in front#SPEC-003.
 */
export const ROLE_SIDE: Record<MessageRole, BubbleSide> = {
	human: 'left',
	ai: 'right',
	system: 'center',
	tool: 'center',
};

export const BUBBLE_CLASS: Record<BubbleSide, string> = {
	left: 'border border-subtle bg-grey-25 text-default',
	right: 'border border-purple-200 bg-purple-25 text-default',
	center: 'text-subtle',
};

/** The square corner that makes a bubble point at its author, WhatsApp style. */
export const TAIL_CLASS: Record<BubbleSide, string> = {
	left: 'rounded-bl-none',
	right: 'rounded-br-none',
	center: '',
};

export const ROW_CLASS: Record<BubbleSide, string> = {
	left: 'justify-start',
	right: 'justify-end',
	center: 'justify-center',
};

/** WhatsApp caps bubbles well short of the column so the eye tracks the side. */
export const BUBBLE_MAX_WIDTH = 'max-w-[65%]';
